var _path, _path2, _path3;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgButton = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1666 15.9987C22.1666 12.6082 19.3904 9.83203 15.9999 9.83203C12.6094 9.83203 9.83325 12.6082 9.83325 15.9987C9.83325 19.3892 12.6094 22.1654 15.9999 22.1654C19.3904 22.1654 22.1666 19.3892 22.1666 15.9987ZM23.1666 15.9987C23.1666 19.9415 19.9427 23.1654 15.9999 23.1654C12.0571 23.1654 8.83325 19.9415 8.83325 15.9987C8.83325 12.0559 12.0571 8.83203 15.9999 8.83203C19.9427 8.83203 23.1666 12.0559 23.1666 15.9987Z",
    fill: "#395ABF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5331 13.7597C17.7284 13.5645 18.0449 13.5645 18.2402 13.7597C18.4354 13.955 18.4354 14.2715 18.2402 14.4667L14.4667 18.2402C14.2715 18.4354 13.955 18.4354 13.7597 18.2402C13.5645 18.0449 13.5645 17.7284 13.7597 17.5331L17.5331 13.7597Z",
    fill: "#395ABF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7597 13.7597C13.955 13.5645 14.2715 13.5645 14.4668 13.7597L18.2402 17.5332L18.2747 17.5709C18.4348 17.7673 18.4232 18.0572 18.2402 18.2402C18.0572 18.4232 17.7673 18.4348 17.5709 18.2747L17.5332 18.2402L13.7597 14.4668C13.5645 14.2715 13.5645 13.955 13.7597 13.7597Z",
    fill: "#395ABF"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgButton, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Button.c112e8bd.svg";
export { ForwardRef as ReactComponent };